import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export type TipoToast = 'erro' | 'sucesso' | 'aviso' | 'info';

type Props = {
  mensagem: string | null;
  tipo?: TipoToast;
  duracaoMs?: number;
  onFechar: () => void;
};

export function Toast({ mensagem, tipo = 'erro', duracaoMs = 5000, onFechar }: Props) {
  useEffect(() => {
    if (!mensagem) return;
    const id = setTimeout(onFechar, duracaoMs);
    return () => clearTimeout(id);
  }, [mensagem, duracaoMs, onFechar]);

  if (!mensagem) return null;

  return createPortal(
    <div className={`toast toast--${tipo}`} role="alert" aria-live="assertive">
      <span className="toast__mensagem">{mensagem}</span>
      <button
        type="button"
        className="toast__fechar"
        aria-label="Fechar"
        data-tooltip-id="icon-tip"
        onClick={onFechar}
      >
        ×
      </button>
    </div>,
    document.body,
  );
}
